export default {
    controls: {
        paper: 'paper',
        scissors: 'scissors',
        rock: 'rock'
    },
    status: {
        win: 'win',
        lose: 'lose'
    },
    sizes: {
        small: 'small',
        large: 'large'
    }
}